import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { BillingPage } from '@/features/subscription/components/billing/billing-page'

export const Route = createFileRoute('/_app/account/billing')({
  component: BillingRoute,
})

function BillingRoute(): JSX.Element {
  return <BillingPage />
}
